export default {
	light: {
		scrim: "neutral0",
		primary: "primary40",
		"primary-container": "primary90",
		"on-primary": "primary100",
		"on-primary-container": "primary10",
		"inverse-primary": "primary80",
		"primary-fixed": "primary90",
		"primary-fixed-dim": "primary80",
		"on-primary-fixed": "primary10",
		"on-primary-fixed-variant": "primary30",
		secondary: "secondary40",
		"secondary-container": "secondary90",
		"on-secondary": "secondary100",
		"on-secondary-container": "secondary10",
		"secondary-fixed": "secondary90",
		"secondary-fixed-dim": "secondary80",
		"on-secondary-fixed": "secondary10",
		"on-secondary-fixed-variant": "secondary30",
		tertiary: "tertiary40",
		"tertiary-container": "tertiary90",
		"on-tertiary": "tertiary100",
		"on-tertiary-container": "tertiary10",
		"tertiary-fixed": "tertiary90",
		"tertiary-fixed-dim": "tertiary80",
		"on-tertiary-fixed": "tertiary10",
		"on-tertiary-fixed-variant": "tertiary30",
		surface: "neutral98",
		"on-surface": "neutral10",
		"on-surface-variant": "neutral-variant30",
		"inverse-surface": "neutral20",
		"inverse-on-surface": "neutral95",
		"surface-dim": "neutral87",
		"surface-bright": "neutral98",
		"surface-container-lowest": "neutral100",
		"surface-container-low": "neutral96",
		"surface-container": "neutral94",
		"surface-container-high": "neutral92",
		"surface-container-highest": "neutral90",
		background: "neutral98",
		"on-background": "neutral10",
		outline: "neutral-variant50",
		"outline-variant": "neutral-variant80",
		error: "error40",
		"error-container": "error90",
		"on-error": "error100",
		"on-error-container": "error10",
		shadow: "neutral0",
	},
	dark: {
		scrim: "neutral0",
		primary: "primary80",
		"primary-container": "primary30",
		"on-primary": "primary20",
		"on-primary-container": "primary90",
		"inverse-primary": "primary40",
		"primary-fixed": "primary90",
		"primary-fixed-dim": "primary80",
		"on-primary-fixed": "primary10",
		"on-primary-fixed-variant": "primary30",
		secondary: "secondary80",
		"secondary-container": "secondary30",
		"on-secondary": "secondary20",
		"on-secondary-container": "secondary90",
		"secondary-fixed": "secondary90",
		"secondary-fixed-dim": "secondary80",
		"on-secondary-fixed": "secondary10",
		"on-secondary-fixed-variant": "secondary30",
		tertiary: "tertiary80",
		"tertiary-container": "tertiary30",
		"on-tertiary": "tertiary20",
		"on-tertiary-container": "tertiary90",
		"tertiary-fixed": "tertiary90",
		"tertiary-fixed-dim": "tertiary80",
		"on-tertiary-fixed": "tertiary10",
		"on-tertiary-fixed-variant": "tertiary30",
		surface: "neutral6",
		"on-surface": "neutral90",
		"on-surface-variant": "neutral-variant80",
		"inverse-surface": "neutral90",
		"inverse-on-surface": "neutral20",
		"surface-dim": "neutral6",
		"surface-bright": "neutral24",
		"surface-container-lowest": "neutral4",
		"surface-container-low": "neutral10",
		"surface-container": "neutral12",
		"surface-container-high": "neutral17",
		"surface-container-highest": "neutral22",
		background: "neutral6",
		"on-background": "neutral90",
		outline: "neutral-variant60",
		"outline-variant": "neutral-variant30",
		error: "error80",
		"error-container": "error30",
		"on-error": "error20",
		"on-error-container": "error90",
		shadow: "neutral0",
	},
}
